/**
 * สมรภูมิธงสามผืน on a zone's map (systems/guildField.ts): where the battlefield lies, how the player plays in it,
 * and the simulated fighters' builds (the arena roster's looks) and monster rules.
 *
 * The battlefield is laid on an open stretch of the zone's own map (`GUILD_FIELD_AT`, field metres from its corner)
 * until the ko world bake can give it a map of its own; a zone without one runs the war unseen (as round 1 did).
 */
import { ARENA_ROSTER } from './arena';
import { MONSTERS, type MonsterDef } from './monsters';

/** The battlefield's north-west corner on each zone's map that has one (an open, level 120 × 90 m stretch). */
export const GUILD_FIELD_AT: Readonly<Record<string, { readonly x: number; readonly y: number }>> = {
  // Yanyu B's western meadows, clear of the town (open and level over the whole 120 × 90 m).
  yanyu2: { x: 25, y: 285 },
};

export const guildFieldOrigin = (zone: string): { readonly x: number; readonly y: number } | null =>
  GUILD_FIELD_AT[zone] ?? null;

export const GUILD_FIELD_PLAY = {
  /** Metres within which an enemy leaves the match's AI and fights the player by hand. */
  engage: 9,
  /** Metres past `engage` at which it goes back to the match. */
  release: 14,
  /** Seconds between the battlefield's state events (`guildWar` `field`) for the HUD and the banners. */
  stateEvery: 0.25,
  /** An enemy's health per point of fighter power. */
  hpPerPower: 14,
} as const;

/** The monster rules of an enemy fighter (its look and name are the roster's, set on the entity). */
export const GUILD_FOE_ID = 'gw-foe';

const FOE: MonsterDef = {
  id: GUILD_FOE_ID,
  name: 'ศัตรูกิลด์',
  level: 12,
  hp: 600,
  atk: 22,
  def: 14,
  speed: 2.6,
  aggro: 9,
  leash: 40,
  decisionRate: 1.1,
  attack: 'bandit-slash',
  break: 'bandit-crush',
  canBlock: true,
  // The war pays at its end (GUILD_WAR_REWARDS), not per foe.
  reward: { cultivation: 0, gold: [0, 0] },
  respawn: null,
  sprite: 'bandit',
  scale: 1,
};

// Registered beside the others (a new file that registers itself: data/monsters.ts is not edited).
(MONSTERS as Record<string, MonsterDef>)[FOE.id] ??= FOE;

/** A simulated fighter's look: one of the arena roster's, picked by its name. */
export function fighterLook(name: string): { readonly sprite: string; readonly title: string } {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  const b = ARENA_ROSTER[h % ARENA_ROSTER.length]!;
  return { sprite: b.sprite, title: b.title };
}
